module.exports = __webpack_public_path__ + "media/images/application/placeholder/placeholder-32x9-7d82b5a330ce9e3451272aa987ca2d55.jpg";